<template>
	<div 
		class="on-off-pill"
		:class="{ 
			minimal: minimal,
			dark: darkMode
		}"
		>
		<label class="the-label">{{ label }}</label>

		<div class="pill-and-status">
			<label>
				<input
					type="checkbox"
					:checked="modelValue"
					@input="newValue"
					/>
				<div class="pill-container">
					<div class="toggler"></div>
				</div>
			</label>

			<div class="status-text">
				{{ modelValue ? 'Enabled' : 'Disabled' }}
			</div>
		</div>

		<div class="instructions" v-if="instructions">
			{{ instructions }}
		</div>
	</div>

</template>

<script>

export default {
	props: {
		modelValue: Boolean,
		minimal: {
			type: Boolean,
			default: false
		},
		label: {
			type: String,
			default: ''
		},
		instructions: {
			type: [Boolean, String],
			default: false
		},
		darkMode: {
			type: Boolean,
			default: false
		}
	},
	emits: ['update:modelValue'],
	data: () => {
		return {
			localValue: null
		}
	},
	mounted(){
		this.localValue = this.modelValue
	},
	methods:{
		newValue(e){
			switch(e.target.checked){
				case true:
					this.localValue = true
					break
				default:
					this.localValue = false
					break
			}
			this.$emit('update:modelValue', this.localValue)
			this.$emit('change', this.localValue)
		}

	}
}

</script>

<style lang="sass" scoped>

.on-off-pill
	margin-right: 10px
	display: flex
	align-items: flex-start
	flex-direction: column

	.the-label
		font-family: 'Roboto Condensed', sans-serif
		font-weight: 700
		font-size: 16px
		line-height: 1.1
		color: #252525
		margin-bottom: 10px

	.pill-and-status
		display: flex
		align-items: center
		gap: 15px

		.status-text
			font-family: 'Roboto Condensed', sans-serif
			font-weight: 400
			font-size: 14px
			line-height: 1.1
			color: #999

	.instructions
		font-family: 'Roboto', sans-serif
		font-weight: 400
		font-size: 12px
		line-height: 1.4
		color: #6a6a6a
		margin-top: 10px

	.pill-container
		height: 40px
		border-radius: 32px
		padding: 4px
		width: 68px
		background-color: #d00
		display: flex
		transition: all 300ms
		box-shadow: 0 0 4px rgba(#000, 0.3)

		.toggler
			background-color: #fff
			box-shadow: 0 0 4px rgba(#000, 0.3)
			border-radius: 50%
			width: 32px
			height: 32px
			transition: all 300ms

	input[type="checkbox"]:checked ~ .pill-container
		background-color: #0d0

		.toggler
			transform: translateX(28px)

	input[type="checkbox"]
		display: none

	&.minimal
		.pill-container
			width: 45px
			height: 20px
			padding: 4px

			.toggler
				width: 20px
				height: 20px

		input[type="checkbox"]:checked ~ .pill-container
			.toggler
				transform: translateX(25px)

	&.dark
		.the-label
			color: #fff

		.instructions
			color: #ccc

		.status-text
			color: #ccc

		.pill-container
			background-color: #333
			box-shadow: 0 0 1px 1px #555

			.toggler
				background-color: #f9f9f9

		input[type="checkbox"]:checked ~ .pill-container
			background-color: #0d0

			.toggler
				background-color: #f9f9f9


</style>